"use strict";

import throttle from "lodash/throttle";

const helper = {
    contain: function ($container, $obj) {
      function test() {
        console.log('object element:' , $container);
        console.log('object width: ', $obj.clientWidth);
        console.log('container width: ', Math.round($container.clientWidth));
        console.log('window inner height: ', Math.round(window.innerHeight * 0.9));

        if (Math.round($obj.clientWidth) >= Math.round($container.clientWidth)) {
          $container.classList.add("pin-width");
        } else {
          $container.classList.remove("pin-width");
        }
        if (
          Math.round($obj.clientHeight) >= Math.round(window.innerHeight * 0.9)
        ) {
          $container.classList.add("pin-height");
        } else {
          $container.classList.remove("pin-height");
        }
      }
      test();
      //window.addEventListener("resize", throttle(test, 300));
    },
  
    cover: function ($container, $obj) {
      function test() {
        const obj_ratio =
          Math.round($obj.clientHeight) / Math.round($obj.clientWidth);
        const container_ratio =
          Math.round($container.clientHeight) /
          Math.round($container.clientWidth);
  
        if (obj_ratio < container_ratio) {
          $container.classList.add("fill-height");
          $container.classList.remove("fill-width");
        }
        if (obj_ratio > container_ratio) {
          $container.classList.add("fill-width");
          $container.classList.remove("fill-height");
        }
      }
      test();
      //window.addEventListener("resize", throttle(test, 300));
    },
  
    fix_page_height: function () {
      compute();
      window.addEventListener("resize", throttle(compute, 100));
  
      function compute() {
        document.body.classList.remove("height-fix");
        if (
          Math.round(document.getElementById("viewport").clientHeight) <=
          Math.round(window.innerHeight)
        ) {
          document.body.classList.add("height-fix");
        } else {
          document.body.classList.remove("height-fix");
        }
      }
    },
};

export default helper;